import React, { useEffect } from 'react'
import Usage from './Usage.tsx'
import SampleMessages from './SampleMessages.tsx'
import Policies from './Policies.tsx'
import Contact from './Contact.tsx'
import PropTypes from 'prop-types'

/**
 * @param {object} props
 */
const Preview = (props) => {
    const { editing, passData, update } = props
    const stepComponents = [
        Usage,
        SampleMessages,
        Policies,
        Contact
    ]
    useEffect(() => {
        if (props.saveId) props.update({ completed: true, gotoNext: true, saveData: {} })
    }, [props.saveId])
    return (<>
        {
            stepComponents.map((comp, index) => {
                const StepComponent = comp
                return <React.Fragment key={index}>
                    <StepComponent update={update} passData={passData} readOnly={true} editing={editing} />
                    <br/>
                </React.Fragment>
            })
        }
    </>)
}

Preview.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    editing: PropTypes.object,
    preview: PropTypes.bool
}

export default Preview
